import React from "react";
import List from "../Import_Inventory/list";

export default function InventoryExport() {
  return <List modeExport={true} />;
}
